<template>
  <Layout>
    <v-container
      class="fill-height"
      fluid
      pa-0
    >
      <v-row class="fill-height">
        <v-col cols="4">
          <v-row class="fill-height">
            <ClientList
              :clients="clients"
              @newClient="clientSelected"
              @refreshClient="getClients"
            />
          </v-row>
        </v-col>
        <v-col class="fill-height">
          <v-row
            class="fill-height"
            align="start"
            justify="start"
          >
            <Answer
              v-if="client !== null"
              :answers="answers"
              :client="client"
            />
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout.vue';
import ClientList from '@/components/ClientList.vue';
import Answer from '@/components/Answer.vue';

export default {
  name: 'Client',
  components: {
    Layout,
    ClientList,
    Answer,
  },
  data() {
    return {
      client: null,
    };
  },

  computed: {
    clients() {
      return this.$store.state.client.clients;
    },
    answers() {
      return this.$store.state.client.answers;
    },
  },
  watch: {},
  beforeMount() {
    this.getClients();
  },
  methods: {
    async getClients() {
      await this.$store.dispatch('client/get');
    },
    async clientSelected(item) {
      this.client = item;
      if (this.client !== null) {
        await this.$store.dispatch('client/answer', this.client.id);
      }
    },
  },
};
</script>
